import { describeGeminiApiError } from '../../utils/aiPrompts';
import { geminiFetch, getGeminiAttempts, describeGeminiAttempts } from '../geminiConfig';

const callGemini = async ({ contents, schema, model }) => {
  const payload = {
    contents,
    generationConfig: {
      responseMimeType: 'application/json',
      responseSchema: schema
    }
  };

  const response = await geminiFetch({ payload, model });

  if (!response.ok) {
    // Google's error body names the actual cause (e.g. "API key not valid") —
    // surface it instead of only the generic per-status description.
    let apiDetail = '';
    try {
      const errorBody = await response.json();
      apiDetail = errorBody?.error?.message ? ` — ${errorBody.error.message}` : '';
    } catch (e) {
      // Body unreadable — keep the generic description.
    }
    // Ohne den Verlauf zeigt die Oberflaeche nur das zuletzt gescheiterte
    // Modell — ein Durchlauf ueber die ganze Liste saehe dann aus, als haette
    // gar kein Fallback stattgefunden.
    const attempts = getGeminiAttempts(response);
    const trail = attempts.length > 1 ? ` · Versucht: ${describeGeminiAttempts(attempts)}` : '';
    throw new Error(`API-Fehler ${describeGeminiApiError(response.status, response.statusText)}${apiDetail}${trail}`);
  }

  const result = await response.json();
  const text = result?.candidates?.[0]?.content?.parts?.[0]?.text;
  if (!text) {
    throw new Error('Unerwartete API-Antwortstruktur.');
  }

  let json;
  try {
    json = JSON.parse(text);
  } catch (e) {
    throw new Error('Antwort konnte nicht als JSON gelesen werden.');
  }

  return { json, modelReplyText: text };
};

export class GeminiChat {
  constructor() {
    this.contents = [];
  }

  async ask({ userText, schema, model }) {
    // Only commit the turn to history after the call succeeds, so a failed
    // turn can be retried without leaving a half-state in the conversation.
    const userTurn = { role: 'user', parts: [{ text: userText }] };
    const { json, modelReplyText } = await callGemini({
      contents: [...this.contents, userTurn],
      schema,
      model
    });
    this.contents.push(userTurn);
    this.contents.push({ role: 'model', parts: [{ text: modelReplyText }] });
    return json;
  }
}
